import React from 'react';
import { Link } from './styles/Link.styled';

function MultilineTitle({ title, description, link, id, dir }) {
  const titleParts = title ? title.split('|') : [];
  const title1 = titleParts[0];
  const title2 = titleParts.length > 1 ? titleParts[1] : '';
  const title3 = titleParts.length > 2 ? titleParts[2] : '';

  return (
    <>
      <h2 id={id}>
        <span>{title1}</span>
        {title2 && <span className="hline">{title2}</span>}
        <span>{title3}</span>
      </h2>
      {description ? <p className="sub1">{description}</p> : null}
      {link ? (
        <div className="link-wrapper" dir={dir}>
          <Link to={link.url} target={link.target}>
            {link.name}
          </Link>
        </div>
      ) : null}
    </>
  );
}

export default MultilineTitle;
